<div class="col-xl">
    <form id="formService" [formGroup]="form">
        <div class="card mb-4">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h4 class="mb-0">Actualizar solicitud</h4>
            </div>

            <!-- Info -->
            <div class="card-body">
                <div class="mb-3 p-3 border rounded">
                    <div class="row g-3">
                        <div class="col-12 col-sm-4 col-lg">
                            <h6><b>Fecha de Solicitud</b></h6>
                            <label class="form-label">{{ data.request_date | date:'dd/MM/yyyy' }}</label>
                        </div>
                        <div class="col-12 col-sm-4 col-lg">
                            <h6><b>Hora de solicitud</b></h6>
                            <label class="form-label">{{ data.request_hour }}</label>
                        </div>
                        <div class="col-12 col-sm-4 col-lg">
                            <h6><b>Usuario</b></h6>
                            <label class="form-label">{{data.user?.name}}</label>
                        </div>
                        <div class="col-12 col-sm-6 col-lg">
                            <h6><b>Unidad</b></h6>
                            <label class="form-label">{{unit.unit}}</label>
                        </div>
                        <div class="col-12 col-sm-6 col-lg">
                            <h6><b>Placas</b></h6>
                            <label class="form-label">{{unit.plates}}</label>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Clasificación -->
            <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                <h4 class="mb-0">¿Como clasificas la solicitud de mantenimiento? Selecciona una opción:</h4>
            </div>
            <div class="card-body mt-0 pb-1">
                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-lg-12 col-xs-12 d-flex">
                            <div *ngFor="let item of priority" class="ms-2">
                                <input type="radio" class="btn-check" formControlName="priority_id" name="priority_id"
                                    id="btn-check{{item.id}}" [value]="item.id" autocomplete="off">
                                <label class="btn btn-primary btn-priority"
                                    for="btn-check{{item.id}}">{{item.name}}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Crítico en ruta / Programar reparación -->
            <ng-container *ngIf="isCriticoOrReparacion">
                <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                    <h4 class="mb-0">Especificación de la falla</h4>
                </div>
                <div class="card-body">
                    <div class="mb-3 p-3 border rounded">
                        <div class="row g-3">
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>¿Donde se encuentra la falla?</b></h6>
                                <select class="form-select" formControlName="maintenance_failure_id"
                                    (change)="onChangeFailure($any($event.target).value)">
                                    <option value="" selected>Seleccionar</option>
                                    <option *ngFor="let item of failerus" [value]="item.id">{{item.name}}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>¿Que tipo de falla es?</b></h6>
                                <select class="form-select" formControlName="maintenance_failure_type_id"
                                    (change)="onChangeType($any($event.target).value)">
                                    <option value="" selected>Seleccionar</option>
                                    <option *ngFor="let t of typesByFailure" [value]="t.id">{{t.name}}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>Detalle de la falla</b></h6>
                                <select class="form-select" formControlName="maintenance_detail_id">
                                    <option value="" selected>Seleccionar</option>
                                    <option *ngFor="let d of detailsByType" [value]="d.id">{{d.name}}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>Km inicial de la unidad a la fecha de la solicitud</b></h6>
                                <input type="number" class="form-control" formControlName="km_inicial" placeholder="0 Km" min="0">
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>Tipo de mantenimiento</b></h6>
                                <select class="form-select" formControlName="maintenance_type_id">
                                    <option value="" selected>Seleccionar</option>
                                    <option *ngFor="let t of maintenanceType" [value]="t.id">{{t.name}}</option>
                                </select>
                            </div>
                            <div class="col-12 col-md-auto d-flex align-items-end">
                                <a class="link-primary" style="cursor:pointer" (click)="openAddFailureModal()">+ Agregar falla</a>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Preventivo -->
            <ng-container *ngIf="isPreventivo">
                <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                    <h4 class="mb-0">Especificaciones de la solicitud</h4>
                </div>
                <div class="card-body">
                    <div class="mb-3 p-3 border rounded">
                        <div class="alert alert-info d-flex align-items-start mb-3" role="alert">
                            <i class="fas fa-info-circle me-2 mt-1 flex-shrink-0"></i>
                            <div>
                                El mantenimiento de los vehículos se realizan cada 10.000 a 15.000 kilómetros o cada 6 meses, lo que ocurra primero. Sin embargo, el tipo de vehículo determina los intervalos exactos y los componentes críticos a inspeccionar:
                                <ul class="mb-0 mt-1">
                                    <li><strong>Vehículos ligeros (furgonetas):</strong> Cambio de aceite y filtros cada 5.000 a 10.000 km.</li>
                                    <li><strong>Camiones ligeros y medianos:</strong> Revisiones mayores cada 15.000 a 20.000 km, con mantenimientos básicos cada 10.000 km.</li>
                                    <li><strong>Camiones pesados y tractocamiones:</strong> Mantenimiento enfocado en motor cada 20.000 a 40.000 km</li>
                                </ul>
                            </div>
                        </div>
                        <div class="row g-3">
                            <div class="col-12 col-md-6">
                                <h6><b>Km inicial de la unidad a la fecha de la solicitud</b></h6>
                                <input type="number" class="form-control" formControlName="km_inicial" placeholder="0 Km" min="0">
                            </div>
                            <div class="col-12 col-md-6">
                                <h6><b>Km estipulado para su próximo mantenimiento</b></h6>
                                <input type="number" class="form-control" formControlName="km_next_maintenance" placeholder="0 Km" min="0">
                            </div>
                            <div class="col-12 col-md-6 col-lg-4">
                                <h6><b>Tipo de mantenimiento</b></h6>
                                <select class="form-select" formControlName="maintenance_type_id">
                                    <option value="" selected>Seleccionar</option>
                                    <option *ngFor="let t of maintenanceType" [value]="t.id">{{t.name}}</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Evidencias -->
            <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0">
                <h4 class="mb-0">Evidencias</h4>
            </div>
            <div class="card-body mt-0 mb-0">
                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-lg-12 col-xs-12">
                            <input type="file" #evidenceInput class="d-none" multiple
                                (change)="onFilesSelected($event)">
                            <a class="upload_file" (click)="$event.preventDefault(); evidenceInput.click();">
                                Subir evidencias de mantenimiento
                            </a>
                            <div *ngIf="selectedPreviews.length" class="mt-2 evidence-previews">
                                <ng-container *ngFor="let preview of selectedPreviews; let i = index">
                                    <div class="thumb-wrapper me-2 mb-2" *ngIf="preview as src">
                                        <img [src]="src" alt="preview" class="thumb-image" />
                                        <button type="button" class="thumb-remove-btn" (click)="openRemoveModal(i)"
                                            data-bs-toggle="modal" data-bs-target="#confirmRemoveModal"
                                            title="Eliminar">
                                            Eliminar evidencia
                                        </button>
                                    </div>
                                </ng-container>
                            </div>
                            <div class="modal fade" id="confirmRemoveModal" tabindex="-1"
                                aria-labelledby="confirmRemoveModalLabel" aria-hidden="true">
                                <div class="modal-dialog modal-dialog-centered">
                                    <div class="modal-content">
                                        <div class="modal-header justify-content-center">
                                            <h4 class="modal-title" id="confirmRemoveModalLabel">Eliminar evidencia</h4>
                                            <button type="button" class="btn-close" data-bs-dismiss="modal"
                                                aria-label="Close"></button>
                                        </div>
                                        <div class="modal-body">
                                            ¿Estas seguro de querer eliminar esta evidencia? Una vez eliminado no se
                                            podrá recuperar y deberas subir otra nuevamente de ser necesario
                                        </div>
                                        <div class="modal-footer justify-content-center">
                                            <button type="button" class="btn btn-outline-primary"
                                                (click)="confirmRemove()" data-bs-dismiss="modal">Eliminar</button>
                                            <button type="button" class="btn btn-primary"
                                                data-bs-dismiss="modal">Cancelar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Materiales y refacciones -->
            <div class="card-header d-flex justify-content-between align-items-center pb-3 pt-0" *ngIf="isInternal || isExternal">
                <h4 class="mb-0">Materiales y refacciones</h4>
            </div>
            <div class="card-body mt-0 pb-1" *ngIf="isInternal || isExternal">
                <div class="mb-3 p-3 border rounded">
                    <div class="mb-3">
                        <div class="form-label mb-2">
                            <h6><b>¿El mantenimiento requiere de refacciones?</b></h6>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="form-check form-check-inline form-check-reverse">
                                <input class="form-check-input" type="radio" formControlName="required_repair"
                                    [value]="true" id="requiredRepairYes">
                                <label class="form-check-label" for="requiredRepairYes">Si</label>
                            </div>
                            <div class="form-check form-check-inline form-check-reverse">
                                <input class="form-check-input" type="radio" formControlName="required_repair"
                                    [value]="false" id="requiredRepairNo">
                                <label class="form-check-label" for="requiredRepairNo">No</label>
                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="form.get('required_repair')?.value === true">
                        <h6 class="mb-2"><b>Agregar refacciones</b></h6>
                        <div class="d-flex gap-2 mb-3">
                            <div class="position-relative flex-grow-1">
                                <i class="fas fa-search spare-search-icon"></i>
                                <input type="text" class="form-control spare-search-input"
                                    placeholder="Buscar refacciones por nombre"
                                    [value]="spareSearchTerm"
                                    (input)="onSpareSearch($event)"
                                    (blur)="hideSpareDropdown()">
                                <div class="list-group position-absolute w-100 shadow-sm spare-dropdown"
                                    *ngIf="showSpareDropdown">
                                    <button type="button" class="list-group-item list-group-item-action py-2"
                                        *ngFor="let r of filteredRepairs"
                                        (mousedown)="selectSpare(r)">
                                        {{ r.name }}
                                    </button>
                                </div>
                            </div>
                            <button type="button" class="btn btn-outline-primary text-nowrap"
                                (click)="openAddRepairModal()">
                                + Agregar refacción
                            </button>
                        </div>
                        <div class="mt-2">
                            <ag-grid-angular
                                class="ag-theme-alpine spare-grid"
                                [columnDefs]="spareColDefs"
                                [defaultColDef]="spareDefaultColDef"
                                [rowData]="selectedRepairs"
                                [domLayout]="'autoHeight'"
                                [overlayNoRowsTemplate]="'<span class=\'text-muted\'>No hay registros para mostrar</span>'"
                                (gridReady)="onSpareGridReady($event)">
                            </ag-grid-angular>
                            <div class="d-flex justify-content-between align-items-center pt-2 border-top"
                                *ngIf="selectedRepairs.length > 0">
                                <small class="text-muted">
                                    Mostrando {{ selectedRepairs.length }} de {{ selectedRepairs.length }} refacciones
                                </small>
                                <div>
                                    <strong>Total refacciones: </strong>
                                    <span class="text-primary fw-bold fs-5">
                                        ${{ totalRepairsAmount | number:'1.2-2' }} MXN
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <hr class="my-3">

                    <div class="mb-3">
                        <div class="form-label mb-2">
                            <h6><b>¿El mantenimiento requiere materiales de inventario?</b></h6>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="form-check form-check-inline form-check-reverse">
                                <input class="form-check-input" type="radio" formControlName="required_material"
                                    [value]="true" id="requiredMaterialYes">
                                <label class="form-check-label" for="requiredMaterialYes">Si</label>
                            </div>
                            <div class="form-check form-check-inline form-check-reverse">
                                <input class="form-check-input" type="radio" formControlName="required_material"
                                    [value]="false" id="requiredMaterialNo">
                                <label class="form-check-label" for="requiredMaterialNo">No</label>
                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="form.get('required_material')?.value === true">
                        <h6 class="mb-2"><b>Agregar materiales</b></h6>
                        <div class="d-flex gap-2 mb-3">
                            <div class="position-relative flex-grow-1">
                                <i class="fas fa-search spare-search-icon"></i>
                                <input type="text" class="form-control spare-search-input"
                                    placeholder="Buscar materiales por nombre"
                                    [value]="materialSearchTerm"
                                    (input)="onMaterialSearch($event)"
                                    (blur)="hideMaterialDropdown()">
                                <div class="list-group position-absolute w-100 shadow-sm spare-dropdown"
                                    *ngIf="showMaterialDropdown">
                                    <button type="button" class="list-group-item list-group-item-action py-2"
                                        *ngFor="let m of filteredMaterials"
                                        (mousedown)="selectMaterial(m)">
                                        {{ m.name }}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="mt-2">
                            <ag-grid-angular
                                class="ag-theme-alpine spare-grid"
                                [columnDefs]="materialColDefs"
                                [defaultColDef]="materialDefaultColDef"
                                [rowData]="selectedMaterials"
                                [domLayout]="'autoHeight'"
                                [overlayNoRowsTemplate]="'<span class=\'text-muted\'>No hay registros para mostrar</span>'"
                                (gridReady)="onMaterialGridReady($event)">
                            </ag-grid-angular>
                            <div class="d-flex justify-content-between align-items-center pt-2 border-top"
                                *ngIf="selectedMaterials.length > 0">
                                <small class="text-muted">
                                    Mostrando {{ selectedMaterials.length }} de {{ selectedMaterials.length }} materiales
                                </small>
                                <div>
                                    <strong>Total materiales: </strong>
                                    <span class="text-primary fw-bold fs-5">
                                        ${{ totalMaterialsAmount | number:'1.2-2' }} MXN
                                    </span>
                                </div>
                            </div>
                        </div>
                    </ng-container>

                    <hr class="my-3">

                    <div class="mb-2">
                        <div class="form-label mb-2">
                            <h6><b>¿El mantenimiento requiere mano de obra externa?</b></h6>
                        </div>
                        <div class="d-flex align-items-center">
                            <div class="form-check form-check-inline form-check-reverse">
                                <input class="form-check-input" type="radio" formControlName="required_labor"
                                    [value]="true" id="requiredLaborYes">
                                <label class="form-check-label" for="requiredLaborYes">Si</label>
                            </div>
                            <div class="form-check form-check-inline form-check-reverse">
                                <input class="form-check-input" type="radio" formControlName="required_labor"
                                    [value]="false" id="requiredLaborNo">
                                <label class="form-check-label" for="requiredLaborNo">No</label>
                            </div>
                        </div>
                    </div>

                    <ng-container *ngIf="form.get('required_labor')?.value === true">
                        <h6 class="fw-bold mt-3 mb-3">Mano de obra</h6>
                        <div class="row g-3">
                            <div class="col-12 col-md-6">
                                <label class="form-label small text-muted mb-1">Costo de mano de obra</label>
                                <div class="position-relative">
                                    <span class="modal-cost-prefix">$</span>
                                    <input type="number" class="form-control modal-cost-input"
                                        formControlName="labor_cost" placeholder="0.00" min="0" step="0.01">
                                    <span class="modal-cost-suffix">MXN</span>
                                </div>
                            </div>
                            <div class="col-12">
                                <label class="form-label small text-muted mb-1">Descripción <span class="text-muted">(Opcional)</span></label>
                                <textarea class="form-control" formControlName="labor_description" rows="4"></textarea>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>

            <!-- Fecha estimada de reparación -->
            <div class="card-body mt-0 pb-1">
                <div class="mb-3 p-3 border rounded">
                    <div class="row">
                        <div class="col-lg-12 col-xs-12">
                            <div class="form-label">
                                <h6><b>Fecha estimado de reparación</b></h6>
                            </div>
                            <div class="row g-2 align-items-end">
                                <div class="col-auto d-flex align-items-center">
                                    <label class="form-label mb-0 me-2"><b>Desde</b></label>
                                    <input type="date" class="form-control w-auto"
                                        formControlName="estimated_time_repair_start">
                                </div>
                                <div class="col-auto d-flex align-items-center">
                                    <label class="form-label mb-0 me-2"><b>Hasta</b></label>
                                    <input type="date" class="form-control w-auto"
                                        formControlName="estimated_time_repair_end">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Botones -->
            <div class="card-body mt-0 mb-0 pt-0">
                <div class="d-flex justify-content-center justify-content-md-end gap-2">
                    <a class="btn btn-outline-primary btn-action" (click)="onCancel()">Cancelar</a>
                    <button type="button" class="btn btn-primary btn-action" [disabled]="form.invalid || submitting"
                        (click)="onSubmit()">
                        {{ submitting ? 'Enviando...' : 'Actualizar solicitud' }}
                    </button>
                </div>
            </div>
        </div>
    </form>

    <!-- Modal: Agregar refacción manual -->
    <div class="modal fade" [class.show]="showAddRepairModal"
        [style.display]="showAddRepairModal ? 'block' : 'none'"
        tabindex="-1" role="dialog" aria-labelledby="addRepairModalLabel">
        <div class="modal-dialog modal-dialog-centered modal-lg">
            <div class="modal-content">
                <div class="modal-header border-0 pb-0">
                    <h5 class="modal-title fw-bold" id="addRepairModalLabel">Agregar refacción</h5>
                    <button type="button" class="btn-close" (click)="showAddRepairModal = false"></button>
                </div>
                <div class="modal-body pt-2">
                    <div class="row g-3">
                        <div class="col-6">
                            <label class="form-label small text-muted mb-1">Nombre de la refacción</label>
                            <input type="text" class="form-control" [(ngModel)]="newRepair.name" [ngModelOptions]="{standalone: true}">
                        </div>
                        <div class="col-6">
                            <label class="form-label small text-muted mb-1">Cantidad</label>
                            <input type="number" class="form-control" [(ngModel)]="newRepair.quantity" [ngModelOptions]="{standalone: true}" min="1">
                        </div>
                        <div class="col-6">
                            <label class="form-label small text-muted mb-1">Categoría</label>
                            <select class="form-select" [(ngModel)]="newRepair.category" [ngModelOptions]="{standalone: true}">
                                <option value="">Seleccionar</option>
                                <option *ngFor="let c of repairCategories" [value]="c.name">{{c.name}}</option>
                            </select>
                        </div>
                        <div class="col-6">
                            <label class="form-label small text-muted mb-1">Costo unitario</label>
                            <div class="position-relative">
                                <span class="modal-cost-prefix">$</span>
                                <input type="number" class="form-control modal-cost-input"
                                    [(ngModel)]="newRepair.unit_cost" [ngModelOptions]="{standalone: true}"
                                    placeholder="0.00" min="0" step="0.01">
                                <span class="modal-cost-suffix">MXN</span>
                            </div>
                        </div>
                        <div class="col-6">
                            <label class="form-label small text-muted mb-1">Proveedor <span class="text-muted">(Opcional)</span></label>
                            <input type="text" class="form-control" [(ngModel)]="newRepair.provider" [ngModelOptions]="{standalone: true}">
                        </div>
                        <div class="col-6">
                            <label class="form-label small text-muted mb-1">Descripción <span class="text-muted">(Opcional)</span></label>
                            <textarea class="form-control" [(ngModel)]="newRepair.description" [ngModelOptions]="{standalone: true}" rows="3"></textarea>
                        </div>
                    </div>
                </div>
                <div class="modal-footer border-0 justify-content-center gap-2">
                    <button type="button" class="btn btn-outline-primary px-4"
                        (click)="showAddRepairModal = false">Cancelar</button>
                    <button type="button" class="btn btn-primary px-4"
                        [disabled]="!newRepair.name.trim() || !newRepair.unit_cost"
                        (click)="confirmAddRepair()">
                        <i class="fas fa-plus me-1"></i> Agregar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" *ngIf="showAddRepairModal"></div>

    <!-- Modal: Agregar falla -->
    <div class="modal fade" [class.show]="showAddFailureModal"
        [style.display]="showAddFailureModal ? 'block' : 'none'"
        tabindex="-1" role="dialog" aria-labelledby="addFailureModalLabel">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header border-0 pb-0">
                    <h5 class="modal-title fw-bold" id="addFailureModalLabel">Agregar falla</h5>
                    <button type="button" class="btn-close" (click)="showAddFailureModal = false"></button>
                </div>
                <div class="modal-body pt-2">
                    <div class="row g-3">
                        <div class="col-6">
                            <label class="form-label small text-muted mb-1">¿Donde se ubica la falla de la unidad?</label>
                            <input type="text" class="form-control" [(ngModel)]="newFailure.failure_name" [ngModelOptions]="{standalone: true}" placeholder="Ingresar">
                        </div>
                        <div class="col-6">
                            <label class="form-label small text-muted mb-1">¿Que tipo de falla es?</label>
                            <input type="text" class="form-control" [(ngModel)]="newFailure.type_name" [ngModelOptions]="{standalone: true}" placeholder="Ingresar">
                        </div>
                        <div class="col-12">
                            <label class="form-label small text-muted mb-1">Detalle de la falla</label>
                            <textarea class="form-control" [(ngModel)]="newFailure.detail_name" [ngModelOptions]="{standalone: true}"
                                rows="4" placeholder="Describe la falla que presenta la unidad"></textarea>
                        </div>
                    </div>
                </div>
                <div class="modal-footer border-0 justify-content-center gap-2">
                    <button type="button" class="btn btn-outline-primary px-4"
                        (click)="showAddFailureModal = false">Cancelar</button>
                    <button type="button" class="btn btn-primary px-4"
                        [disabled]="!newFailure.failure_name.trim() || !newFailure.type_name.trim() || !newFailure.detail_name.trim()"
                        (click)="confirmAddFailure()">
                        + Agregar
                    </button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show" *ngIf="showAddFailureModal"></div>

    <ngx-spinner bdColor="rgba(0, 0, 0, 0.7)" size="medium" color="#fff" type="ball-atom">
        <div class="loader"></div>
        <p style="font-size: 20px; color: white">{{text_loading}}</p>
    </ngx-spinner>

</div>
